export const Factions = Object.freeze({
    AXIS: "axis",
    ALLIES: "allies"
});